import axios from "axios";
import { message } from 'antd';
import { BaseUrl } from './../utils/globalConst'
let headers = {};
//axios请求拦截
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem("token");
        config.baseURL = BaseUrl;
        config.timeout = 6000;
        // if (config.method == 'post' || config.method == 'put') {
        //     config.transformRequest = [function (data) {
        //         let ret = '';
        //         for (let it in data) {
        //             ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        //         }
        //         return ret;
        //     }];
        // }
        // config.headers = {
        //     'Accept': "application/json, text/plain, */*",
        //     'Content-Type': "application/x-www-form-urlencoded"
        // };
        if (token) {
            config.headers['Authorization'] = token
        }
        return config;
    },
    error => {
        //console.log('error', error);
        return Promise.reject(error);
    }
)

/**
 * 响应的拦截
 */
axios.interceptors.response.use(
    res => {
        if (res.status) {
            switch (res.status) {
                case 500:
                    message.error("服务器异常");
                    break;
                case 404:
                    message.error("网络请求地址不存在");
                    break;
                case 200:
                    break;
                default:
                    message.error('请求出错');
                    break;
            }
        }
        return res;
    },
    error => {
        return Promise.resolve(error.response);
    }
);

function checkStatus(response) {
    // loading
    // 如果http状态码正常，则直接返回数据
    if (response) {
        if (response.data && response.data.code == 4001) {
            message.error('登陆失效，请重新登陆', 2).then(() => {
                window.open(`/#/login`, '_self');
            });
        }
        return response.data;
        // 如果不需要除了data之外的数据，可以直接 return response.data
    }
    // 异常状态下，把错误信息返回去
    return {
        code: 404,
        msg: "请求出错"
    };
}

export default {
    loginPost(options) {
        var data = options.params || {};
        let config={
            headers,
            transformRequest : [function (data) {
                let ret = '';
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                }
                return ret;
            }]
        }
        return axios
            .post(options.block + options.url, data,config)
            .then(response => {
                return checkStatus(response);
            }).catch(function (err) {
                message.error("哦豁，请求异常！！！");
                //console.log(err);
            });
    },
    loginOut(options) {
        // window.open(`/#/login`, '_self');
        // return axios
        //     .get(options.block + options.url, { params: {} })
        //     .then(response => {
        //         return response.data;
        //     }).catch(function (err) {
        //         message.error("哦豁，请求异常！！！");
        //         //console.log(err);
        //     });
    },
    post(options) {
        var data = options.params || {};
        let config;
        if (options.format === 'JSON') {
            config = {
                headers:{
                    ...headers,
                    'Content-Type': 'application/json'
                }
            };
        }else{
            config={
                headers,
                transformRequest : [function (data) {
                    let ret = '';
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                    }
                    return ret;
                }]
            }
        }
        
        return axios
            .post(options.block + options.url, data,config)
            .then(response => {
                return checkStatus(response);
            }).catch(function (err) {
                message.error("哦豁，请求异常！！！");
                //console.log(err);
            });
    },
    put(options) {
        var data = options.params || {};
        let config;
        if (options.format === 'JSON') {
            config = {
                headers:{
                    ...headers,
                    'Content-Type': 'application/json'
                }
            };
        }else{
            config={
                headers,
                transformRequest : [function (data) {
                    let ret = '';
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                    }
                    return ret;
                }]
            }
        }
        return axios
            .put(options.block + options.url, data,config)
            .then(response => {
                return checkStatus(response);
            }).catch(function (err) {
                message.error("哦豁，请求异常！！！");
                //console.log(err);
            });
    },
    get(options) {
        var data = options.params || {};
        return axios
            .get(options.block + options.url, { params: data })
            .then(response => {
                return checkStatus(response);
            }).catch(function (err) {
                message.error("哦豁，请求异常！！！");
                //console.log(err);
            });
    },
    delete(options) {
        var data = options.params || {};
        return axios
            .delete(options.block + options.url, { params: data })
            .then(response => {
                return checkStatus(response);
            }).catch(function (err) {
                message.error("哦豁，请求异常！！！");
                //console.log(err);
            });
    }
}



// WEBPACK FOOTER //
// ./src/axios/index.js